import { __read, __spreadArray } from "tslib";
import React, { createContext, useState } from 'react';
var DebugInfoProvider;
export var DevuiToolContext = createContext(undefined);
export var DevuiToolContextProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState([]), 2), debugInfos = _b[0], setDebugInfos = _b[1];
    DebugInfoProvider = { debugInfos: debugInfos, setDebugInfos: setDebugInfos };
    return (React.createElement(DevuiToolContext.Provider, { value: { debugInfos: debugInfos, setDebugInfos: setDebugInfos } }, children));
};
var DiagnosticsLogger = /** @class */ (function () {
    function DiagnosticsLogger() {
    }
    DiagnosticsLogger.prototype.log = function (debugInfo) {
        DebugInfoProvider.setDebugInfos(__spreadArray(__spreadArray([], __read(DebugInfoProvider.debugInfos), false), [
            debugInfo,
        ], false));
    };
    return DiagnosticsLogger;
}());
export var diagnosticsLogger = new DiagnosticsLogger();
//# sourceMappingURL=DevuiToolContextProvider.js.map